import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  verticalList,
  stateList,
  activitytypList,
  statusList,
  createProject,
  updateProject,
  getProjectDataByID,
  showContributors,
  uploadFile,
  showImage,
  deleteProjectActivity,
} from "../http/api";
import { useAuth } from "../http/authcontex";
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import countryList from "react-select-country-list";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import {
  FaRegTrashAlt,
  FaPlus,
  FaRegSave,
  FaTimes,
  FaDownload,
} from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../loading/loading";

import "./project.css";

const months = [
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
];

export default function ProjectForm() {
  const { authContext, userRoles, userZone } = useAuth();
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const location = useLocation();
  const { userEmail } = useAuth();
  const navigate = useNavigate();

  const [isEditMode, setIsEditMode] = useState(false);
 
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const initialFormData = {
    zone: "",
    type: "",
    vertical: "",
    scheme: "",
    state: [],
    clientName: "",
    lastProposalDate: "",
    projectStartDate: null,
    projectEndDate: null,
    consultancy: 0,
    status: "",
    country: "India",
    remark: "",
    users: [],
    address: "",
    narrative_description_of_project: "",
    professional_staff_provided: 0,
    name_of_Senior_Staff: "",
    name_of_associated_consultants: "",
    services_provided: "",

    activityDetails: [
      {
        activityType: "",
        dateOfActivity: null,
        timeSpent: 0,
        achivAmount: 0,
        relization: 0,
        revenueAmount: 0,
        activityDetails: "",
      },
    ],
    target: months.map((month) => ({
      month,
      target: 0,
      achiv: 0,
      paymentTarget: 0,
      relization: 0,
      revenueAmount: 0,
    })),
    submittedBy: userEmail,
    active: true,
    sop: [],
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  const [formData, setFormData] = useState(initialFormData);
  const [financialYear, setFinancialYear] = useState("2026-27");
  const [activeTab, setActiveTab] = useState(1);
  const [errors, setErrors] = useState({});

  const [stateOptions, setStateOptions] = useState([]);
  const [contributorsOptions, setContributorsOptions] = useState([]);
  const [verticalOptions, setVerticalOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [activitytypOptions, setActivityTypOptions] = useState([]);

 // const [currentPage, setCurrentPage] = useState(1);  //add for pagination
  //const [rowsPerPage, setRowsPerPage] = useState(25); // add for pagination

  const isActivityRowEmpty = (activity) => {
    return (
      !activity.activityType &&
      !activity.dateOfActivity &&
      !activity.timeSpent &&
      !activity.achivAmount &&
      !activity.revenueAmount &&
      !activity.relization &&
      !activity.activityDetails
    );
  };

  const handleCancelDelete = () => {
    setActivityToDeleteIndex(null);
    setShowDeleteModal(false);
  };

  const handleDeleteActivity = (index) => {
    setFormData((prev) => {
      const updatedActivityDetails = [...prev.activityDetails];
      updatedActivityDetails.splice(index, 1);
      return { ...prev, activityDetails: updatedActivityDetails };
    });
  };

  const [zoneOptions] = useState(() => {
    const options = [
      { value: "north", label: "North" },
      { value: "south", label: "South" },
      { value: "west", label: "West" },
    ];

    if (userRoles.includes("ADMIN")) {
      return options;
    } else if (userZone.includes("north")) {
      return options.filter((option) => option.value === "north");
    } else if (userZone.includes("south")) {
      return options.filter((option) => option.value === "south");
    } else if (userZone.includes("west")) {
      return options.filter((option) => option.value === "west");
    } else {
      return options;
    }
  });

  const [typeOptions] = useState([
    { value: "new_business_assigned", label: "New Business" },
    { value: "spill_over_assigned", label: "Spill Over" },
    { value: "other", label: "Other" },
  ]);

  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSort = (key) => {
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: "asc" }
    );
  };

  // const filteredActivities = formData.activityDetails.filter((activity) => {
  //   const lowerSearch = searchTerm.toLowerCase();

  //   const isSearchMatch =
  //     activity.activityType?.toLowerCase().includes(lowerSearch) ||
  //     activity.activityDetails?.toLowerCase().includes(lowerSearch) ||
  //     String(activity.achivAmount || "").includes(lowerSearch) ||
  //     String(activity.revenueAmount || "").includes(lowerSearch) ||
  //     String(activity.relization || "").includes(lowerSearch) ||
  //     String(activity.timeSpent || "").includes(lowerSearch) ||
  //     (activity.dateOfActivity &&
  //       new Date(activity.dateOfActivity)
  //         .toLocaleDateString("en-GB")
  //         .includes(lowerSearch));

  //   const isSubmittedByMe = activity.activitySubmitedBy === userEmail;
  //   const isBillOrPayment =
  //     activity.activityType === "Bill Submitted" ||
  //     activity.activityType === "Payment Received";

  //   if (userRoles.includes("ADMIN") || userRoles.includes("MGR")) {
  //     return isSearchMatch;
  //   } else {
  //     return isSearchMatch && (isSubmittedByMe || isBillOrPayment);
  //   }
  // });

  const filteredActivities = formData.activityDetails.filter((activity) => {
    const lowerSearch = searchTerm.toLowerCase();

    // Format the activity date to DD-MM-YYYY
    const dateStr = activity.dateOfActivity || "";
    let formattedDate = "";
    if (dateStr) {
      const dateObj = new Date(dateStr);
      const day = String(dateObj.getDate()).padStart(2, "0");
      const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Month is 0-based
      const year = dateObj.getFullYear();
      formattedDate = `${day}-${month}-${year}`; // DD-MM-YYYY
    }

    return (
      activity.activityType?.toLowerCase().includes(lowerSearch) ||
      activity.activityDetails?.toLowerCase().includes(lowerSearch) ||
      String(activity.achivAmount || "").includes(lowerSearch) ||
      String(activity.revenueAmount || "").includes(lowerSearch) ||
      String(activity.relization || "").includes(lowerSearch) ||
      String(activity.timeSpent || "").includes(lowerSearch) ||
      formattedDate.includes(lowerSearch) ||
      (activity.activitySubmitedBy?.toLowerCase() || "").includes(lowerSearch)
    );
  });

  const sortedActivities = [...filteredActivities];
  if (sortConfig.key) {
    sortedActivities.sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];

      if (!aVal && !bVal) return 0;
      if (!aVal) return 1;
      if (!bVal) return -1;

      if (typeof aVal === "number" && typeof bVal === "number") {
        return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
      }

      return sortConfig.direction === "asc"
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });
  }

  const viewStateDetails = useCallback(() => {
    stateList()
      .then((response) => {
        if (response.status === 200) {
          const stateDropdownOptions = response.data.map((state) => ({
            value: state.name,
            label: state.name,
          }));
          setStateOptions(stateDropdownOptions);
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          authContext.logout();
          navigate("");
        }
      });
  }, [authContext, navigate]);

  const viewContributorsDetails = useCallback(() => {
    showContributors()
      .then((response) => {
        if (response.status === 200) {
          const contributorsOptions = response.data.map((user) => ({
            value: user.id,
            label: user.name,
          }));
          setContributorsOptions(contributorsOptions);
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          authContext.logout();
          navigate("");
        }
      })
      .finally(() => setLoading(false));
  }, [authContext, navigate]);

  const viewVerticalDetails = useCallback(() => {
    verticalList()
      .then((response) => {
        if (response.status === 200) {
          const verticalDropdownOptions = response.data.map((vertical) => ({
            value: vertical.name,
            label: vertical.name,
          }));
          setVerticalOptions(verticalDropdownOptions);
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          authContext.logout();
          navigate("");
        }
      })
      .finally(() => setLoading(false));
  }, [authContext, navigate]);

  const viewStatusDetails = useCallback(() => {
    statusList()
      .then((response) => {
        if (response.status === 200) {
          const statusDropdownOptions = response.data.map((status) => ({
            value: status.name,
            label: status.name,
          }));
          setStatusOptions(statusDropdownOptions);
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          authContext.logout();
          navigate("");
        }
      })
      .finally(() => setLoading(false));
  }, [authContext, navigate]);

  const viewActivityTypeDetails = useCallback(() => {
    activitytypList()
      .then((response) => {
        if (response.status === 200) {
          const activitytypDropdownOptions = response.data.map((activity) => ({
            value: activity.name,
            label: activity.name,
          }));
          setActivityTypOptions(activitytypDropdownOptions);
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          authContext.logout();
          navigate("");
        }
      })
      .finally(() => setLoading(false));
  }, [authContext, navigate]);

  const fetchProjectData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getProjectDataByID(id);
      if (response.status === 200) {
        const projectData = response.data;


        console.log("projectData:", JSON.stringify(projectData, null, 2));

        let stateArray = [];
        if (projectData.state) {
          stateArray = Array.isArray(projectData.state)
            ? projectData.state
            : projectData.state.split(", ").filter(Boolean);
        }

        let sopFilesArray = [];
        if (projectData.sop) {
          sopFilesArray =
            typeof projectData.sop === "string"
              ? projectData.sop
                .split(",")
                .map((file) => file.trim())
                .filter(Boolean)
              : projectData.sop;
        }

        const transformedData = {
          id: projectData.id,
          zone: projectData.zone || "",
          type: projectData.type || "",
          vertical: projectData.vertical || "",
          scheme: projectData.scheme || "",
          state: stateArray,
          status: projectData.status || "",
          clientName: projectData.clientName || "",
          lastProposalDate: projectData.lastProposalDate || "",
          projectStartDate: projectData.projectStartDate || null,
          projectEndDate: projectData.projectEndDate || null,
          consultancy: projectData.consultancy || 0,
          remark: projectData.remark || "",
          address: projectData.address || "",
          country: projectData.country || "India",
          narrative_description_of_project:
            projectData.narrative_description_of_project || "",
          professional_staff_provided:
            projectData.professional_staff_provided || 0,
          name_of_Senior_Staff: projectData.name_of_Senior_Staff || "",
          name_of_associated_consultants:
            projectData.name_of_associated_consultants || "",
          services_provided: projectData.services_provided || "",
          users: projectData.users?.map((user) => user.id) || [],
          activityDetails: projectData.activityDetails?.map((activity) => ({
            id: activity.id || 0,
            activityType: activity.activityType || "",
            dateOfActivity: activity.dateOfActivity || null,
            timeSpent: activity.timeSpent || 0,
            achivAmount: activity.achivAmount || 0,
            revenueAmount: activity.revenueAmount || 0,
            relization: activity.relization || 0,
            activityDetails: activity.activityDetails || "",
            activitySubmitedBy: activity.activitySubmitedBy || "",

          })) || [
              {
                id: 0,
                activityType: "",
                dateOfActivity: "",
                timeSpent: 0,
                achivAmount: 0,
                revenueAmount: 0,
                relization: 0,
                activityDetails: "",
              },
            ],
          target:
            projectData.target?.map((t) => ({
              id: t.id || 0,
              month: t.month,
              target: t.target || 0,
              achiv: t.achiv || 0,
              paymentTarget: t.paymentTarget || 0,
              relization: t.relization || 0,
              revenueAmount: t.revenueAmount || 0,
            })) ||
            months.map((month) => ({
              month,
              target: 0,
              achiv: 0,
              paymentTarget: 0,
              relization: 0,
              revenueAmount: 0,
            })),
          sop: sopFilesArray,
        };

        setFormData(transformedData);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        authContext.logout();
        navigate("");
      } else {
        toast.error("Failed to load project data");
      }
    } finally {
      setLoading(false);
    }
  }, [id, authContext, navigate]);

  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      fetchProjectData();
    }

    if (location.state?.financialYear) {
      setFinancialYear(location.state.financialYear);
    }

    viewStateDetails();
    viewContributorsDetails();
    viewVerticalDetails();
    viewStatusDetails();
    viewActivityTypeDetails();
  }, [
    id,
    location.state,
    fetchProjectData,
    viewStateDetails,
    viewContributorsDetails,
    viewVerticalDetails,
    viewStatusDetails,
    viewActivityTypeDetails,
  ]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  function safeBtoa(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }

  function safeAtob(str) {
    return decodeURIComponent(escape(window.atob(str)));
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTargetChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      target: prev.target.map((t, i) =>
        i === index ? { ...t, [field]: Number(value) || 0 } : t
      ),
    }));
  };

  const handleZoneChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      zone: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleTypeChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      type: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleCountryChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      country: selectedOption ? selectedOption.label : "",
    }));
  };

  const handleAddressChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      address: value,
    }));
  };

  const handleContributorsChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];

    setFormData((prev) => ({
      ...prev,
      users: selectedValues,
    }));
  };

  const handleStatusTypChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      status: selectedOption?.value || "",
    }));
  };

  const handleVerticalChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      vertical: selectedOption?.value || null,
    }));
  };

  const handleActivityDetailChange = (index, e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updatedActivityDetails = [...prev.activityDetails];
      updatedActivityDetails[index] = {
        ...updatedActivityDetails[index],
        [name]:
          name === "timeSpent" ||
            name === "achivAmount" ||
            name === "revenueAmount" ||
            name === "relization"
            ? Number(value)
            : value,
      };
      return { ...prev, activityDetails: updatedActivityDetails };
    });
  };

  const handleActivityTypeChange = (index, selectedOption) => {
    setFormData((prev) => {
      const updatedActivityDetails = [...prev.activityDetails];
      updatedActivityDetails[index] = {
        ...updatedActivityDetails[index],
        activityType: selectedOption.value,
      };
      return { ...prev, activityDetails: updatedActivityDetails };
    });
  };

  const addActivityDetail = () => {
    setFormData((prev) => ({
      ...prev,
      activityDetails: [
        ...prev.activityDetails,
        {
          id: 0,
          activityType: "",
          dateOfActivity: "",
          timeSpent: 0,
          achivAmount: 0,
          revenueAmount: 0,
          relization: 0,
          activityDetails: "",
          activitySubmitedBy: userEmail,
        },
      ],
    }));
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [activityToDeleteIndex, setActivityToDeleteIndex] = useState(null);

  const confirmDeleteActivity = (index) => {
    setActivityToDeleteIndex(index);
    setShowDeleteModal(true);
  };

  // const handleDeleteConfirm = () => {
  //   if (activityToDeleteIndex !== null) {
  //     setFormData((prev) => {
  //       const updatedActivityDetails = [...prev.activityDetails];
  //       updatedActivityDetails.splice(activityToDeleteIndex, 1);
  //       return { ...prev, activityDetails: updatedActivityDetails };
  //     });
  //     setActivityToDeleteIndex(null);
  //   }
  //   setShowDeleteModal(false);
  // };
  const handleDeleteConfirm = async () => {
    if (activityToDeleteIndex !== null) {
      const activity = formData.activityDetails[activityToDeleteIndex];

      if (activity?.id && isEditMode) {
        try {
          const response = await deleteProjectActivity(formData.id, activity.id);
          if (response.status === 200 || response.status === 204) {
            toast.success("Activity deleted successfully.");
          } else {
            toast.error("Failed to delete activity from server.");
            return;
          }
        } catch (error) {
          toast.error("Error deleting activity.");
          console.error(error);
          return;
        }
      }

      setFormData((prev) => {
        const updatedActivityDetails = [...prev.activityDetails];
        updatedActivityDetails.splice(activityToDeleteIndex, 1);
        return { ...prev, activityDetails: updatedActivityDetails };
      });

      setActivityToDeleteIndex(null);
      setShowDeleteModal(false);
    }
  };
  const calculatePercentage = (target, achievement) => {
    if (!target || target === 0) return 0;
    return (((achievement || 0) / target) * 100).toFixed(2);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.zone) newErrors.zone = "Zone is required";
    if (!formData.type) newErrors.type = "Type is required";
    if (!formData.vertical) newErrors.vertical = "Vertical is required";
    if (!formData.scheme)
      newErrors.scheme = "Business Name/Scheme Name is required";
    if (!Array.isArray(formData.state) || formData.state.length === 0)
      newErrors.state = "At least one state must be selected";
    if (!Array.isArray(formData.users) || formData.users.length === 0)
      newErrors.users = "At least one contributor must be selected";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [isDisabled, setIsDisabled] = useState(false);
  const MAX_FILE_SIZE = 20 * 1024 * 1024;

  const handleSOPChange = async (e) => {
    const files = Array.from(e.target.files);
    const currentFileCount = formData.sop.length;
    const totalFilesAfterAdd = currentFileCount + files.length;

    if (totalFilesAfterAdd > 4) {
      toast.error("You can upload a maximum of 4 files only.");
      e.target.value = null;
      return;
    }

    setLoading(true);
    try {
      let uploadedFileNames = [];

      for (const file of files) {
        if (file.size > MAX_FILE_SIZE) {
          toast.error(
            `File "${file.name}" is too large. Maximum allowed size is 20MB.`
          );
          e.target.value = null;
          return;
        } else {
          if (file instanceof File) {
            const formDataFile = new FormData();
            const newFileName = `${Date.now()}_${file.name}`;
            formDataFile.append("file", file);
            formDataFile.append("keyName", newFileName);
            const uploadResponse = await uploadFile(formDataFile);
            if (
              uploadResponse.status === 200 ||
              uploadResponse.status === 202
            ) {
              uploadedFileNames.push(newFileName);
            } else {
              toast.error(`Failed to upload SOP file: ${file.name}`);
              setLoading(false);
              e.target.value = null;
              return;
            }
          }
        }
      }

      setFormData((prev) => ({
        ...prev,
        sop: [...prev.sop, ...uploadedFileNames],
      }));
    } catch {
      toast.error("Error uploading files");
    } finally {
      setLoading(false);
      e.target.value = null;
    }
  };

  const handleRemoveSOPFile = (index) => {
    setFormData((prev) => {
      const newFiles = [...prev.sop];
      newFiles.splice(index, 1);
      return { ...prev, sop: newFiles };
    });
  };

  const handleDownloadSOPFile = async (index) => {
    try {
      setLoading(true);
      const file = formData.sop[index];
      if (!file) return;

      if (file instanceof File) {
        const url = URL.createObjectURL(file);
        const a = document.createElement("a");
        a.href = url;
        a.download = file.name;
        a.click();
        URL.revokeObjectURL(url);
      } else if (typeof file === "string") {
        const response = await showImage(file);
        if (response.status === 200 || response.status === 202) {
          setLoading(false);
          const byteArray = new Uint8Array(response.data);
          const blob = new Blob([byteArray], {
            type: response.headers["content-type"],
          });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = file;
          a.click();
          URL.revokeObjectURL(url);
        } else {
          setLoading(false);
          toast.error("Failed to download file");
        }
      }
    } catch {
      setLoading(false);
      toast.error("Error downloading file");
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Please fix all errors before submitting");
      return;
    }

    for (let i = 0; i < formData.activityDetails.length; i++) {
      const activity = formData.activityDetails[i];

      if (
        activity.activityType === "Bill Submitted" &&
        (!activity.achivAmount || activity.achivAmount <= 0)
      ) {
        toast.error(
          `Please enter a valid Bill Amount greater than zero for Activity #${i + 1
          }`
        );
        return;
      }

      if (
        activity.activityType === "Payment Received" &&
        (!activity.relization || activity.relization <= 0)
      ) {
        toast.error(
          `Please enter a valid Payment Received amount greater than zero for Activity #${i + 1
          }`
        );
        return;
      }
    }

    setLoading(true);
    setIsDisabled(true);

    try {
      const formattedUsers = formData.users.map((userId) => {
        const user = contributorsOptions.find((u) => u.value === userId);
        return {
          id: userId,
          name: user ? user.label : "Unknown",
        };
      });

      const stateValue = Array.isArray(formData.state)
        ? formData.state.join(", ")
        : String(formData.state || "");

      const submissionData = {
        ...(isEditMode && { id: formData.id }),
        zone: formData.zone,
        type: formData.type,
        scheme: formData.scheme,
        state: stateValue,
        vertical: formData.vertical,
        fy: financialYear,
        country: formData.country,
        address: formData.address,
        narrative_description_of_project:
          formData.narrative_description_of_project,
        professional_staff_provided: Number(
          formData.professional_staff_provided || 0
        ),
        name_of_Senior_Staff: formData.name_of_Senior_Staff,
        name_of_associated_consultants: formData.name_of_associated_consultants,
        services_provided: formData.services_provided,

        activityDetails: formData.activityDetails.map((activity) => ({
          ...(activity.id && { id: activity.id }),
          activityType: activity.activityType,
          dateOfActivity: activity.dateOfActivity,
          timeSpent: activity.timeSpent,
          achivAmount: activity.achivAmount,
          revenueAmount: activity.revenueAmount,
          relization: activity.relization,
          activityDetails: activity.activityDetails,
          activitySubmitedBy: activity.activitySubmitedBy || userEmail,
        })),
        target: formData.target.map((t) => ({
          ...(t.id && { id: t.id }),
          month: t.month,
          target: t.target,
          paymentTarget: t.paymentTarget,
          relization: t.relization,
          achiv: t.achiv,
          revenueAmount: t.revenueAmount,
        })),
        submittedBy: userEmail,
        clientName: formData.clientName,
        lastProposalDate: formData.lastProposalDate,
        projectStartDate: formData.projectStartDate,
        projectEndDate: formData.projectEndDate,
        consultancy: formData.consultancy,
        status: formData.status,
        remark: formData.remark,
        users: formattedUsers,
        active: true,
        sop: formData.sop.join(", "),
      };

      console.log("submissionData:", JSON.stringify(submissionData, null, 2));

      const request = isEditMode
        ? updateProject(submissionData)
        : createProject(submissionData);

      const response = await request;

      if (response && (response.status === 200 || response.status === 201)) {
        toast.success(
          `Project ${isEditMode ? "updated" : "created"} successfully!`
        );

        if (response.data) {
          const stateArray = response.data.state
            ? Array.isArray(response.data.state)
              ? response.data.state
              : response.data.state.split(", ").filter(Boolean)
            : [];

          const usersArray = response.data.users?.map((user) => user.id) || [];

          setFormData({
            ...response.data,
            state: stateArray,
            users: usersArray,
            activityDetails: response.data.activityDetails || [
              {
                id: 0,
                activityType: "",
                dateOfActivity: "",
                timeSpent: 0,
                achivAmount: 0,
                revenueAmount: 0,
                relization: 0,
                activityDetails: "",
              },
            ],
            target:
              response.data.target ||
              months.map((month) => ({
                month: 0,
                target: 0,
                achiv: 0,
                paymentTarget: 0,
                relization: 0,
                revenueAmount: 0,
              })),
            sop: response.data.sop
              ? typeof response.data.sop === "string"
                ? response.data.sop
                  .split(",")
                  .map((f) => f.trim())
                  .filter(Boolean)
                : response.data.sop
              : [],
          });
          setIsDisabled(false);
        }
        setLoading(false);
        setTimeout(() => {
          if (!isEditMode) {
            navigate("/project");
          }
        }, 1000);
      } else {
        console.log("setLoading ..............");
        setLoading(false);
        setIsDisabled(false);
        throw new Error(
          response?.data?.message ||
          `Failed to ${isEditMode ? "update" : "create"} project`
        );
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        error.message ||
        `An error occurred while ${isEditMode ? "updating" : "creating"}`
      );
      setLoading(false);
      setIsDisabled(false);
    }
  };

  useEffect(() => {
    if (location.state?.financialYear) {
      setFinancialYear(location.state.financialYear);
    }
  }, [location.state]);

  return (
     <div className={`sb-nav-fixed ${isSidebarCollapsed ? "collapsed" : ""}`}>
      {loading && <Loading />}
      <TopNav toggleSidebar={toggleSidebar} />
      <div id="layoutSidenav">
        <SideNave
          isSidebarCollapsed={isSidebarCollapsed}
          toggleSidebar={toggleSidebar}
          
        />
        <div id="layoutSidenav_content">
          <main>
            <div className="container-fluid px-4">
              <h6 className="mt-4">
                {isEditMode
                  ? `Edit Project - Financial Year: ${financialYear}`
                  : `Add New Project - Financial Year: ${financialYear}`}
              </h6>
              <div className="card mb-4 border-0">
                <div className="card-body">
                  <ul className="nav nav-tabs nav-fill">
                    <li className="nav-item">
                      <button
                        className={`nav-item nav-link ${activeTab === 1 ? "active" : ""
                          }`}
                        onClick={() => handleTabChange(1)}
                      >
                        Account
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-item nav-link ${activeTab === 4 ? "active" : ""
                          }`}
                        onClick={() => handleTabChange(4)}
                      >
                        Project Details
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-item nav-link ${activeTab === 2 ? "active" : ""
                          }`}
                        onClick={() => handleTabChange(2)}
                      >
                        Targets & Achievements
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-item nav-link ${activeTab === 3 ? "active" : ""
                          }`}
                        onClick={() => handleTabChange(3)}
                      >
                        Activities
                      </button>
                    </li>
                  </ul>
                  <form className="mt-3">
                    {activeTab === 1 && (
                      <div className="container">
                        <div className="row mb-1">
                          <div className="col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Zone
                            </label>
                            <Select
                              name="zone"
                              value={
                                zoneOptions.find(
                                  (option) => option.value === formData.zone
                                ) || null
                              }
                              onChange={handleZoneChange}
                              options={zoneOptions}
                              className="form-control form-control-sm p-0"
                              placeholder="Select Zone"
                              isSearchable
                            />
                            {errors.zone && (
                              <div className="text-danger small">
                                {errors.zone}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Type
                            </label>
                            <Select
                              name="type"
                              value={
                                typeOptions.find(
                                  (option) => option.value === formData.type
                                ) || null
                              }
                              onChange={handleTypeChange}
                              options={typeOptions}
                              className="form-control form-control-sm p-0"
                              placeholder="Select Type"
                              isSearchable
                            />
                            {errors.type && (
                              <div className="text-danger small">
                                {errors.type}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row mb-1">
                          <div className="col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Vertical
                            </label>
                            <Select
                              name="vertical"
                              value={
                                verticalOptions.find(
                                  (option) => option.value === formData.vertical
                                ) || null
                              }
                              onChange={handleVerticalChange}
                              options={verticalOptions}
                              className="form-control form-control-sm p-0"
                              placeholder="Select Vertical"
                              isSearchable
                            />
                            {errors.vertical && (
                              <div className="text-danger small">
                                {errors.vertical}
                              </div>
                            )}
                          </div>

                          <div className="col-sm-12 col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Business Name/Scheme Name
                            </label>
                            <input
                              type="text"
                              name="scheme"
                              value={formData.scheme}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                              placeholder="Enter Scheme Name/Department"
                            />
                            {errors.scheme && (
                              <div className="text-danger small">
                                {errors.scheme}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row mb-1">
                          <div className="col-sm-12 col-md-3">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Client Name
                            </label>
                            <input
                              type="text"
                              name="clientName"
                              value={formData.clientName}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                              placeholder="Enter Client Name"
                            />
                            {errors.clientName && (
                              <div className="text-danger small">
                                {errors.clientName}
                              </div>
                            )}
                          </div>

                          <div className="col-sm-12 col-md-3">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Last Proposal Submission Date
                            </label>
                            <input
                              type="date"
                              name="lastProposalDate"
                              value={formData.lastProposalDate || ""}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                              placeholder="Enter Last Proposal Submission Date"
                            />
                            {errors.lastProposalDate && (
                              <div className="text-danger small">
                                {errors.lastProposalDate}
                              </div>
                            )}
                          </div>

                          <div className="col-sm-12 col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Contributors
                            </label>
                            <Select
                              name="user"
                              value={contributorsOptions.filter(
                                (option) =>
                                  Array.isArray(formData.users) &&
                                  formData.users.includes(option.value)
                              )}
                              onChange={handleContributorsChange}
                              options={contributorsOptions}
                              className="form-control form-control-sm p-0"
                              placeholder="Select Contributors"
                              isSearchable
                              isMulti
                            />
                            {errors.users && (
                              <div className="text-danger small">
                                {errors.users}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row mb-1">
                          <div className="col-sm-12 col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Project Start Date
                            </label>
                            <input
                              type="date"
                              name="projectStartDate"
                              value={formData.projectStartDate || ""}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                              placeholder="Enter Project Start Date"
                            />
                            {errors.projectStartDate && (
                              <div className="text-danger small">
                                {errors.projectStartDate}
                              </div>
                            )}
                          </div>

                          <div className="col-sm-12 col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Project End Date
                            </label>
                            <input
                              type="date"
                              name="projectEndDate"
                              value={formData.projectEndDate || ""}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                              placeholder="Enter Project End Date"
                            />
                            {errors.projectEndDate && (
                              <div className="text-danger small">
                                {errors.projectEndDate}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row mb-1">
                          <div className="col-sm-12 col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Consultancy Value (Expected/Actual)
                            </label>
                            <input
                              type="number"
                              name="consultancy"
                              value={formData.consultancy}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                              placeholder="Enter Consultancy Value"
                            />
                            {errors.consultancy && (
                              <div className="text-danger small">
                                {errors.consultancy}
                              </div>
                            )}
                          </div>

                          <div className="col-sm-12 col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              State Covered
                            </label>
                            <CreatableSelect
                              name="state"
                              isMulti
                              isSearchable
                              isClearable
                              placeholder="Select or type State(s)"
                              options={stateOptions}
                              value={(formData.state || []).map((val) => ({
                                label: val,
                                value: val,
                              }))}
                              onChange={(selectedOptions) => {
                                const selectedValues = selectedOptions
                                  ? selectedOptions.map((opt) => opt.value)
                                  : [];
                                setFormData((prev) => ({
                                  ...prev,
                                  state: selectedValues,
                                }));
                              }}
                              onCreateOption={(inputValue) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  state: [...prev.state, inputValue],
                                }));
                              }}
                              className="form-control form-control-sm p-0"
                              classNamePrefix="select"
                              noOptionsMessage={() =>
                                "Type to enter a new state"
                              }
                              formatCreateLabel={(inputValue) =>
                                `Use "${inputValue}"`
                              }
                            />

                            {errors.state && (
                              <div className="text-danger small">
                                {errors.state}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row mb-1">
                          {/* Country */}
                          <div className="col-sm-12 col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Country
                            </label>
                            <Select
                              name="country"
                              options={countryList().getData()}
                              value={countryList()
                                .getData()
                                .find(
                                  (c) =>
                                    c.label === (formData.country || "India")
                                )}
                              onChange={handleCountryChange}
                              className="form-control form-control-sm p-0"
                              classNamePrefix="select"
                              placeholder="Select Country"
                            />
                          </div>

                          {/* Address */}
                          <div className="col-sm-12 col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Address
                            </label>
                            <input
                              type="text"
                              name="address"
                              value={formData.address}
                              onChange={handleAddressChange}
                              className="form-control form-control-sm"
                              placeholder="Enter Address"
                            />
                          </div>
                        </div>

                        <div className="row mb-1">
                          <div className="col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Status
                            </label>
                            <Select
                              name="status"
                              value={
                                statusOptions.find(
                                  (option) => option.value === formData.status
                                ) || null
                              }
                              onChange={handleStatusTypChange}
                              options={statusOptions}
                              className="form-control form-control-sm p-0"
                              placeholder="Select Status"
                              isSearchable
                            />
                          </div>

                          <div className="col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Remarks
                            </label>
                            <textarea
                              name="remark"
                              value={formData.remark}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                              placeholder="Enter Remarks"
                            />
                          </div>

                          <div className="col-md-6 file-upload-container">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              SOP
                            </label>
                            <input
                              type="file"
                              name="sop"
                              multiple
                              onChange={handleSOPChange}
                              className="form-control form-control-sm file-input"
                              placeholder="Upload SOP files"
                            />
                            <div className="file-selected-count">
                              {formData.sop.length} file
                              {formData.sop.length !== 1 ? "s" : ""} selected
                            </div>

                            <div className="file-preview-container">
                              {Array.isArray(formData.sop) &&
                                formData.sop.map((file, index) => (
                                  <div
                                    key={index}
                                    className="file-preview-item d-flex align-items-center mb-1"
                                  >
                                    <input
                                      type="text"
                                      className="form-control form-control-sm me-2"
                                      readOnly
                                      value={
                                        typeof file === "string"
                                          ? file
                                          : file.name
                                      }
                                      title={
                                        typeof file === "string"
                                          ? file
                                          : file.name
                                      }
                                      style={{ maxWidth: "70%" }}
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger me-2"
                                      onClick={() => handleRemoveSOPFile(index)}
                                      title="Remove file"
                                    >
                                      <FaTimes />
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() =>
                                        handleDownloadSOPFile(index)
                                      }
                                      title="Download file"
                                    >
                                      <FaDownload />
                                    </button>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>

                        <div className="spacer"></div>
                      </div>
                    )}

                    {activeTab === 2 && (
                      <div className="row mt-3">
                        <div className="col-12">
                          <h5>Monthly Targets & Achievements</h5>
                          <div className="table-responsive">
                            <table className="table table-bordered table-sm">
                              <thead className="bg-light">
                                <tr>
                                  <th>Month</th>
                                  <th>Turnover Target</th>
                                  <th>Payment Target</th>
                                  <th>Achievement</th>
                                  <th>Realization</th>
                                  <th>Revenue</th>
                                  <th>% Achievement Completion</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.target.map((targetObj, index) => (
                                  <tr key={index}>
                                    <td>{targetObj.month}</td>
                                    <td>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        value={
                                          targetObj.target === 0
                                            ? ""
                                            : targetObj.target || ""
                                        }
                                        placeholder="Enter Turnover Target"
                                        onChange={(e) =>
                                          handleTargetChange(
                                            index,
                                            "target",
                                            e.target.value
                                          )
                                        }
                                        readOnly={
                                          !userRoles.includes("ADMIN") &&
                                          !userRoles.includes("MGR")
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        value={
                                          targetObj.paymentTarget === 0
                                            ? ""
                                            : targetObj.paymentTarget || ""
                                        }
                                        placeholder="Enter Payment Target"
                                        onChange={(e) =>
                                          handleTargetChange(
                                            index,
                                            "paymentTarget",
                                            e.target.value
                                          )
                                        }
                                        readOnly={
                                          !userRoles.includes("ADMIN") &&
                                          !userRoles.includes("MGR")
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        value={targetObj.achiv || "0"}
                                        readOnly
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        value={targetObj.relization || "0"}
                                        readOnly
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        value={targetObj.revenueAmount || "0"}
                                        readOnly
                                      />
                                    </td>
                                    <td>
                                      {calculatePercentage(
                                        (targetObj.target || 0) +
                                        (targetObj.paymentTarget || 0), // add payment target
                                        (targetObj.achiv || 0) +
                                        (targetObj.relization || 0) // add achive for percentage
                                      )}
                                      %
                                    </td>
                                  </tr>
                                ))}
                                <tr className="fw-bold">
                                  <td>Grand Total</td>
                                  <td>
                                    {formData.target.reduce(
                                      (sum, t) => sum + (t?.target || 0),
                                      0
                                    )}
                                  </td>
                                  <td>
                                    {formData.target.reduce(
                                      (sum, t) => sum + (t?.paymentTarget || 0),
                                      0
                                    )}
                                  </td>
                                  <td>
                                    {formData.target.reduce(
                                      (sum, t) => sum + (t?.achiv || 0),
                                      0
                                    )}
                                  </td>
                                  <td>
                                    {formData.target.reduce(
                                      (sum, t) => sum + (t?.relization || 0),
                                      0
                                    )}
                                  </td>
                                  <td>
                                    {formData.target.reduce(
                                      (sum, t) => sum + (t?.revenueAmount || 0),
                                      0
                                    )}
                                  </td>
                                  <td>
                                    {calculatePercentage(
                                      formData.target.reduce(
                                        (sum, t) =>
                                          sum +
                                          (t?.target || 0) +
                                          (t?.paymentTarget || 0), // add payment target
                                        0
                                      ),
                                      formData.target.reduce(
                                        (sum, t) =>
                                          sum +
                                          (t?.achiv || 0) +
                                          (t?.relization || 0), // add realization
                                        0
                                      )
                                    )}
                                    %
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === 3 && (
                      <>
                        {/* 🔍 Search Input */}
                        <div className="d-flex justify-content-end mb-3">
                          <div className="d-flex align-items-center">
                            <input
                              type="text"
                              placeholder="Search..."
                              className="form-control form-control-sm me-5"
                              value={searchTerm}
                              onChange={handleSearch}
                            />
                            {/* <button className="btn btn-sm btn-secondary" disabled>
                              <FaSearch /> 
                            </button>*/}
                          </div>
                        </div>

                        {/* Scrollable Table */}
                        <div
                          className="activity-table-wrapper mb-3"
                          style={{
                            maxHeight: "calc(5rem * 5 + 1rem)",
                            overflowY: "auto",
                            border: "1px solid #dee2e6",
                            borderRadius: "0.25rem",
                            backgroundColor: "#fff",
                          }}
                        >
                          
                            <table className="table-bordered table-sm responsive-table"> 
                              <thead className="table-bordered">
                                <tr>
                                  <th
                                    style={{ cursor: "pointer", width: "15%" }}
                                    onClick={() => handleSort("activityType")}
                                  >
                                    Type{" "}
                                    {sortConfig.key === "activityType" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    style={{ cursor: "pointer", width: "5%" }}
                                    onClick={() => handleSort("dateOfActivity")}
                                  >
                                    Date{" "}
                                    {sortConfig.key === "dateOfActivity" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th className="time-spent-header">Time Spent in hrs.</th>
                                  <th className="bill-amt-header"
                                    style={{ cursor: "pointer", width: "9%" }}
                                    onClick={() => handleSort("achivAmount")}
                                  >
                                    Bill Amt{" "}
                                    {sortConfig.key === "achivAmount" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    style={{ cursor: "pointer", width: "9%" }}
                                    onClick={() => handleSort("revenueAmount")}
                                  >
                                    Revenue{" "}
                                    {sortConfig.key === "revenueAmount" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    style={{ cursor: "pointer", width: "9%" }}
                                    onClick={() => handleSort("relization")}
                                  >
                                    Payment{" "}
                                    {sortConfig.key === "relization" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th>Outcome</th>
                                  <th
                                    style={{ cursor: "pointer", width: "9%" }}
                                  >Sumb. By</th>
                                  <th style={{ width: "5%" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                
                                {sortedActivities
                                  .map((activity, index) => ({
                                    activity,
                                    index,
                                  }))
                                  .reverse()
                                  .map(({ activity, index }, displayIndex) => (
                                    <tr key={index}>
                                      {/* Type */}
                                      <td data-label="Type">
                                        <Select
                                          value={
                                            activitytypOptions.find(
                                              (opt) =>
                                                opt.value ===
                                                activity.activityType
                                            ) || null
                                          }
                                          onChange={(selected) =>
                                            handleActivityTypeChange(
                                              index,
                                              selected
                                            )
                                          }
                                          options={activitytypOptions}
                                          className="form-control p-0"
                                          placeholder="Select"
                                          isSearchable
                                          menuPortalTarget={document.body} // 👈 render dropdown outside table
                                          styles={{
                                            menuPortal: (base) => ({
                                              ...base,
                                              zIndex: 9999,
                                            }), // 👈 make sure it's above everything
                                          }}
                                        />
                                      </td>

                                      {/* Date */}
                                      <td data-label="Date">
                                        <input
                                          type="date"
                                          name="dateOfActivity"
                                          value={activity.dateOfActivity || ""}
                                          onChange={(e) =>
                                            handleActivityDetailChange(index, e)
                                          }
                                          className="form-control form-control-sm"
                                        />
                                      </td>

                                      {/* Time Spent */}
                                      <td data-label="Time Spent in Hrs.">
                                        <input
                                          type="number"
                                          name="timeSpent"
                                          value={
                                            activity.timeSpent !== undefined &&
                                              activity.timeSpent !== null
                                              ? activity.timeSpent
                                              : ""
                                          }
                                          onChange={(e) =>
                                            handleActivityDetailChange(index, e)
                                          }
                                          className="form-control form-control-sm"
                                          placeholder="Hours"
                                          step="0.1"
                                          min="0"
                                          inputMode="decimal"
                                          
                                        />
                                      </td>

                                      {/* Bill Amt */}
                                      <td data-label="Amount">
                                        <input
                                          type="number"
                                          name="achivAmount"
                                          disabled={
                                            activity.activityType !==
                                            "Bill Submitted"
                                          }
                                          value={
                                            activity.achivAmount === 0
                                              ? ""
                                              : activity.achivAmount || ""
                                          }
                                          onChange={(e) =>
                                            handleActivityDetailChange(index, e)
                                          }
                                          className="form-control form-control-sm"
                                          placeholder="₹"
                                        />
                                      </td>

                                      {/* Revenue */}
                                      <td data-label="Revenue">
                                        <input
                                          type="number"
                                          name="revenueAmount"
                                          disabled={
                                            activity.activityType !==
                                            "Bill Submitted"
                                          }
                                          value={
                                            activity.revenueAmount === 0
                                              ? ""
                                              : activity.revenueAmount || ""
                                          }
                                          onChange={(e) =>
                                            handleActivityDetailChange(index, e)
                                          }
                                          className="form-control form-control-sm"
                                          placeholder="₹"
                                        />
                                      </td>

                                      {/* Payment */}
                                      <td data-label="Payment">
                                        <input
                                          type="number"
                                          name="relization"
                                          disabled={
                                            activity.activityType !==
                                            "Payment Received"
                                          }
                                          value={
                                            activity.relization === 0
                                              ? ""
                                              : activity.relization || ""
                                          }
                                          onChange={(e) =>
                                            handleActivityDetailChange(index, e)
                                          }
                                          className="form-control form-control-sm"
                                          placeholder="₹"
                                        />
                                      </td>

                                      {/* Remark */}
                                      <td data-label="Outcome">
                                        <textarea
                                          name="activityDetails"
                                          value={activity.activityDetails}
                                          onChange={(e) =>
                                            handleActivityDetailChange(index, e)
                                          }
                                          className="form-control form-control-sm"
                                          placeholder="Enter Outcomes"
                                          rows="2"
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          value={activity.activitySubmitedBy || ""}
                                          disabled
                                        />
                                      </td>



                                      {/* Action Buttons */}
                                      <td>
                                        <div className="d-flex justify-content-end gap-1">
                                          {/* Add Activity Button on top row */}
                                          {displayIndex === 0 && (
                                            <button
                                              type="button"
                                              className="btn btn-success btn-sm"
                                              title="Add Activity"
                                              onClick={addActivityDetail}
                                            >
                                              <FaPlus />
                                            </button>
                                          )}
                                          {formData.activityDetails.length >
                                            1 && (
                                              <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                title="Delete"
                                                onClick={() => {
                                                  if (
                                                    isActivityRowEmpty(activity)
                                                  ) {
                                                    // Directly delete without confirmation
                                                    handleDeleteActivity(index);
                                                  } else {
                                                    // Ask for confirmation
                                                    confirmDeleteActivity(index);
                                                  }
                                                }}
                                              >
                                                <FaRegTrashAlt />
                                              </button>
                                            )}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          
                        </div>
                      </>
                    )}

                    {activeTab === 4 && (
                      <div className="container">
                        <div className="row mb-1">
                          {/* Description of Project */}
                          <div className="col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Project Description
                            </label>
                            <ReactQuill
                              theme="snow"
                              className="rich-editor-lg"
                              value={safeAtob(
                                formData.narrative_description_of_project || ""
                              )}
                              onChange={(value) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  narrative_description_of_project:
                                    safeBtoa(value),
                                }))
                              }
                            />
                          </div>

                          {/* Professional Staff Provided */}
                          <div className="col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Professional Staff Provided (Nos.)
                            </label>
                            <input
                              type="number"
                              name="professional_staff_provided"
                              value={formData.professional_staff_provided}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                              placeholder="Enter number"
                            />
                          </div>
                        </div>

                        <div className="row mb-1">
                          {/* Name of Senior Staff */}
                          <div className="col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Name of Senior Staff
                            </label>
                            <ReactQuill
                              theme="snow"
                              className="rich-editor-lg"
                              value={safeAtob(
                                formData.name_of_Senior_Staff || ""
                              )}
                              onChange={(value) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  name_of_Senior_Staff: safeBtoa(value),
                                }))
                              }
                            />
                          </div>

                          {/* Services Provided */}
                          <div className="col-md-6">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Services Provided
                            </label>
                            <ReactQuill
                              theme="snow"
                              className="rich-editor-lg"
                              value={safeAtob(formData.services_provided || "")}
                              onChange={(value) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  services_provided: safeBtoa(value),
                                }))
                              }
                            />
                          </div>
                        </div>

                        <div className="row mb-3">
                          {/* Name of Associated Consultancy */}
                          <div className="col-md-12">
                            <label className="form-label form-control-sm mb-0 ps-0">
                              Name of Associated Consultancy
                            </label>
                            <textarea
                              name="name_of_associated_consultants"
                              value={formData.name_of_associated_consultants}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                              rows={2}
                              placeholder="Enter consultancy name"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="text-start mt-4">
                      <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={isDisabled}
                        className="btn-submit"
                      >
                        {isDisabled
                          ? "Sending..."
                          : isEditMode
                            ? "Update"
                            : "Save"}{" "}
                        <FaRegSave />
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      {showDeleteModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-danger text-white">
                <h5 className="modal-title">Confirm Deletion</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCancelDelete}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to delete this activity? This action
                  cannot be undone.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancelDelete}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDeleteConfirm}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
